// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1P1_u","actionsCol":"EnrolledClinics_actionsCol__2v1JF"};